import { DecryptData, EncryptData } from "./encryptDecrypt";

let lang = DecryptData(localStorage.getItem("lang"))
if (!lang || lang === null) lang = "en"

const setLanguage = (value) => {
  if (!value) return
  localStorage.setItem('lang', EncryptData(value));
  lang = value;
}

const updateLanguage = (language = undefined) => {
  if (language) {
    lang = language
  }
}

const multiLangData = {
  parent_en: {
    "Progress and Performance Reports": "Progress and Performance Reports",
    "Comprehensive analysis to track your progress": "Comprehensive analysis to track your child's progress",
    "Highlights": "Highlights",
    "Area of Strength": "Area of Strength",
    "Area of Improvement": "Area of Improvement",
    "Overall Accuracy": "Overall Accuracy",
    "Overall-Acc": "Overall",
    "Overall": "Overall",
    "Accuracy": "Accuracy",
    "Attendance": "Attendance",
    "Overall Attendance": "Overall Attendance",
    "Subject-wise Analysis": "Subject-wise Analysis",
    "Subject-wise data driven analysis to monitor your performance": "Subject-wise data driven analysis to monitor your child's performance",
    "Learn Content": "Learn Content",
    "Subject wise learn content accessed": "Subject wise learn content accessed",
    "Practice Learn Content": "Practice Learn Content",
    "Subject wise Practice-L content accessed": "Subject wise Practice-L content accessed",
    "Attendance Percentage": "Attendance Percentage",
    "Track your subject-wise attendance percentage": "Track your child's subject-wise attendance percentage",
    "Accuracy Percentage": "Accuracy Percentage",
    "Monitor your subject-wise accuracy percentage": "Monitor your child's subject-wise accuracy percentage",
    "Time Analysis-LPT": "Time Analysis-LPT",
    "Monitor time spent on Learn, Practice, Test in Minutes": "Monitor time spent on Learn, Practice, Test in Minutes",
    "Monitor time spent on Live classes in Minutes": "Monitor time spent on Live classes in Minutes",
    "Weekly Test Performance": "Weekly Test Performance",
    "Monitor your weekly test performance": "Monitor your child's weekly test performance",
    "Homework Analysis": "Homework Analysis",
    "Monitor your homework analysis": "Monitor your child's homework analysis",
    "Category Analysis": "Category Analysis",
    "Track content accessed based on services as per L P & T": "Track content accessed based on services as per L P & T",
    "Monitor your performance in different categories with respect to L, P & T": "Monitor child’s performance in Learn, Practice, and Test",
    "Learn": "Learn",
    "Practice-T": "Practice-T",
    "Test": "Test",
    "Key Areas of Improvement": "Key Areas of Improvement",
    "Identify and work on weak areas to ace your exams": "Identify and work on weak areas to ace your child's exams",
    "Learn & Practice - Learn Progress": "Learn & Practice - Learn Progress",
    "Test and Practice-Test Performance": "Test and Practice-Test Performance",
    "Access Learn content to view the reports": "Access Learn content to view the reports",
    "Access Practice-L content to view the reports": "Access Practice-L content to view the reports",
    "Attempt Practice-T and Tests to view the reports": "Attempt Practice-T and Tests to view the reports",
    "Attend live classes to view the reports": "Attend live classes to view the reports",
    "Access and Attempt LPT to view the reports": "Access and Attempt LPT to view the reports",
    "Attempt Weekly Tests to view the reports": "Attempt Weekly Tests to view the reports",
    "Attempt homework to view the reports": "Attempt homework to view the reports",
    "Access learn and Practice-L content to view the reports": "Access learn and Practice-L content to view the reports",
    "Reports": "Reports",
    "Subject": "Subject",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "Practice-L": "Practice-L",
    "Subject wise Practice-Learn content accessed": "Subject wise Practice-Learn content accessed",
    "Time Analysis- Live Class": "Time Analysis- Live Class",
    "Monitor time spent on Live Classes in Minutes": "Monitor time spent on Live Classes in Minutes",
    "Monitor your homework performance": "Monitor your child's homework performance",
  },
  parent_hi: {
    "Progress and Performance Reports": "प्रगति और प्रदर्शन का विवरण देखें",
    "Comprehensive analysis to track your progress": "अपने बच्चे की प्रगति को देखने के लिए विस्तृत विश्लेषण",
    "Highlights": "मुख्य अंश",
    "Area of Strength": "मजबूत क्षेत्र",
    "Area of Improvement": "सुधार के क्षेत्र",
    "Overall Accuracy": "संपूर्ण यथार्थता",
    "Overall-Acc": "संपूर्ण",
    "Select Subject":'विषय-चयन',
    "Overall": "कुल",
    "Accuracy": "यथार्थता",
    "Attendance": "उपस्थिति",
    "Overall Attendance": "कुल उपस्थिति",
    "Subject-wise Analysis": "विषयगत विश्लेषण",
    "Subject-wise data driven analysis to monitor your performance":
      "आपके परिणाम को दिखाने के लिए विषयगत आकड़ें आधारित विश्लेषण",
    "Learn Content": "अध्ययनार्थ विषय सामग्री",
    "Subject wise learn content accessed": "विषयगत सामग्री का अध्ययन",
    "Practice Learn Content": "अध्ययन सामग्री का अभ्यास",
    "Subject wise Practice-L content accessed": "विषयगत अभ्यास सामग्री का अध्ययन",
    "Attendance Percentage": "उपस्थिति का प्रतिशत",
    "Track your subject-wise attendance percentage": "विषयगत उपस्थिति का प्रतिशत",
    "Accuracy Percentage": "वास्तविक प्रतिशत",
    "Monitor your subject-wise accuracy percentage": "विषयगत उपस्थिति का प्रतिशत जानें/ देखें",
    "Time Analysis LPT": "समय विश्लेषण",
    "Time Analysis": "समय विश्लेषण",
    "Monitor time spent on Learn, Practice, Test in Minutes": "LPT पर बिताया गया समय, मिनटों में",
    "Monitor time spent on Live classes in Minutes": "लाइव क्लासेस में बिताया गया समय, मिनटों में",
    "Weekly Test Performance": "साप्ताहिक परीक्षण परिणाम",
    "Monitor your weekly test performance": "साप्ताहिक परीक्षण का परिणाम देखें",
    "Homework Analysis": "गृहकार्य का विश्लेषण",
    "Monitor your homework analysis": "गृहकार्य का विश्लेषण देखें",
    "Category Analysis": "श्रेणीगत विश्लेषण",
    "Track content accessed based on services as per L P & T": "L P & T सेवाओं के आधार पर एक्सेस की गई अध्ययन सामग्री को देखें",
    "Monitor child's performance in different categories with respect to L, P & T": "L, P & T के संबंध में विभिन्न श्रेणियों में अपने बच्चे का प्रदर्शन देखें",
    "Learn": "सीखें",
    "Practice-T": "अभ्यास परीक्षण",
    "Test": "परीक्षण",
    "Key Areas of Improvement": "सुधार के प्रमुख क्षेत्र",
    "Identify and work on weak areas to ace your child's exams": "अपने बच्चे की परीक्षा में सफलता प्राप्ति के लिए, कमजोर क्षेत्रों को पहचान कर सुधारें",
    "Learn & Practice - Learn Progress": "अध्ययन और अभ्यास – अध्ययन में प्रगति",
    "Test and Practice-Test Performance": "परीक्षण और अभ्यास - अभ्यास परिणाम",
    "Access Learn content to view the reports": "विवरण देखने के लिए अध्ययन सामग्री को एक्सेस करें",
    "Access Practice-L content to view the reports": "विवरण देखने के लिए अभ्यास अध्ययन सामग्री को एक्सेस करें",
    "Attempt Practice-T and Tests to view the reports": "विवरण देखने के लिए अभ्यास परीक्षण तथा परीक्षण दें",
    "Attend live classes to view the reports": "विवरण देखने के लिए लाइव क्लास अटेंड करें",
    "Access and Attempt LPT to view the reports": "विवरण देखने के लिए LPT  को एक्सेस करें और प्रयास करें",
    "Attempt Weekly Tests to view the reports": "विवरण देखने के लिए साप्ताहिक परीक्षण दें",
    "Attempt homework to view the reports": "विवरण देखने के लिए गृहकार्य करें",
    "Access learn and Practice-L content to view the reports": "विवरण देखने के लिए अधिगम और अभ्यास अध्ययन सामग्री एक्सेस करें",
    "Reports": "रिपोर्ट्स",
    "Subject": "विषय",
    "Start Date": "आरंभ दिनांक",
    "End Date": "समाप्ति दिनांक",
    "Practice L": "अभ्यास सीखें",
    "Subject wise Practice-Learn content accessed": "विषयगत अभ्यास सामग्री का अध्ययन",
    "Time Analysis- Live Class": "समय विश्लेषण- लाइव क्लास",
    "Time Analysis (Live Class)": "समय विश्लेषण- लाइव क्लास",
    "Monitor time spent on LPT in Minutes":"L,P & T पर बिताए गए समय, मिनटों में",
    "Monitor time spent on Live Classes in Minutes": "लाइव क्लास टाइम विश्लेषण, मिनटों में",
    "Practice T": "अभ्यास परीक्षण",
    "Monitor your homework performance": "गृहकार्य का परिणाम देखें",
    "Identify and work on weak areas to ace your exams": "अपने बच्चे की परीक्षा में सफलता प्राप्ति के लिए, कमजोर क्षेत्रों को पहचान कर सुधारें",
    "Monitor your performance in different categories with respect to L, P & T": "L, P & T के संबंध में विभिन्न श्रेणियों में अपने प्रदर्शन को देखें",
  },
  hi: {
    "Progress and Performance Reports": "प्रगति और प्रदर्शन का विवरण देखें",
    "Comprehensive analysis to track your progress": "आपकी प्रगति को देखने के लिए विस्तृत विश्लेषण",
    "Highlights": "मुख्य अंश",
    "Area of Strength": "मजबूत क्षेत्र",
    "Monitor time spent on LPT in Minutes":"L,P & T पर बिताए गए समय, मिनटों में",
    "Area of Improvement": "सुधार के क्षेत्र",
    "Overall Accuracy": "संपूर्ण यथार्थता",
    "Overall-Acc": "संपूर्ण",
    "Overall": "कुल",
    "Accuracy": "यथार्थता",
    "Attendance": "उपस्थिति",
    "Overall Attendance": "कुल उपस्थिति",
    "Subject-wise Analysis": "विषयगत विश्लेषण",
    "Subject-wise data driven analysis to monitor your performance":
      "आपके परिणाम को दिखाने के लिए विषयगत आकड़ें आधारित विश्लेषण",
    "Learn Content": "अध्ययनार्थ विषय सामग्री",
    "Subject wise learn content accessed": "विषयगत सामग्री का अध्ययन",
    "Practice-Learn Content": "अध्ययन सामग्री का अभ्यास",
    "Subject wise Practice-L content accessed": "विषयगत अभ्यास सामग्री का अध्ययन",
    "Attendance Percentage": "उपस्थिति का प्रतिशत",
    "Track your subject-wise attendance percentage": "विषयगत उपस्थिति का प्रतिशत",
    "Accuracy Percentage": "वास्तविक प्रतिशत",
    "Monitor your subject-wise accuracy percentage": "विषयगत उपस्थिति का प्रतिशत जानें/ देखें",
    "Time Analysis LPT": "समय विश्लेषण",
    "Monitor time spent on Learn, Practice, Test in Minutes": "LPT पर बिताया गया समय, मिनटों में",
    "Monitor time spent on Live classes in Minutes": "लाइव क्लासेस में बिताया गया समय, मिनटों में",
    "Weekly Test Performance": "साप्ताहिक परीक्षण परिणाम",
    "Monitor your weekly test performance": "साप्ताहिक परीक्षण का परिणाम देखें",
    "Homework Analysis": "गृहकार्य का विश्लेषण",
    "Monitor your homework analysis": "गृहकार्य का विश्लेषण देखें",
    "Category Analysis": "श्रेणीगत विश्लेषण",
    "Track content accessed based on services as per L P & T": "L P & T सेवाओं के आधार पर एक्सेस की गई अध्ययन सामग्री को देखें",
    "Monitor your performance in different categories with respect to L, P & T": "L, P & T के संबंध में विभिन्न श्रेणियों में अपने प्रदर्शन को देखें",
    "Learn": "सीखें",
    "Practice-T": "अभ्यास परीक्षण",
    "Practice T": "अभ्यास परीक्षण",
    "Practice Learn Content": "अध्ययन सामग्री का अभ्यास",
    "Test": "परीक्षण",
    "Key Areas of Improvement": "सुधार के प्रमुख क्षेत्र",
    "Identify and work on weak areas to ace your exams": "अपनी परीक्षा में सफलता प्राप्ति के लिए, कमजोर क्षेत्रों को पहचान कर सुधारें",
    "Learn & Practice - Learn Progress": "अध्ययन और अभ्यास – अध्ययन में प्रगति",
    "Test and Practice-Test Performance": "परीक्षण और अभ्यास - अभ्यास परिणाम",
    "Access Learn content to view the reports": "विवरण देखने के लिए अध्ययन सामग्री को एक्सेस करें",
    "Access Practice-L content to view the reports": "विवरण देखने के लिए अभ्यास अध्ययन सामग्री को एक्सेस करें",
    "Attempt Practice-T and Tests to view the reports": "विवरण देखने के लिए अभ्यास परीक्षण तथा परीक्षण दें",
    "Attend live classes to view the reports": "विवरण देखने के लिए लाइव क्लास अटेंड करें",
    "Access and Attempt LPT to view the reports": "विवरण देखने के लिए LPT  को एक्सेस करें और प्रयास करें",
    "Attempt Weekly Tests to view the reports": "विवरण देखने के लिए साप्ताहिक परीक्षण दें",
    "Attempt homework to view the reports": "विवरण देखने के लिए गृहकार्य करें",
    "Access learn and Practice-L content to view the reports": "विवरण देखने के लिए अधिगम और अभ्यास अध्ययन सामग्री एक्सेस करें",
    "Reports": "रिपोर्ट्स",
    "Subject": "विषय",
    "Select Subject":'विषय-चयन',
    "Start Date": "आरंभ दिनांक",
    "End Date": "समाप्ति दिनांक",
    "Practice L": "अभ्यास सीखें",
    "Subject wise Practice-Learn content accessed": "विषयगत अभ्यास सामग्री का अध्ययन",
    "Time Analysis (Live Class)": "समय विश्लेषण- लाइव क्लास",
    "Time Analysis": "समय विश्लेषण",
    "Monitor time spent on Live Classes in Minutes": "लाइव क्लास टाइम विश्लेषण, मिनटों में",
    "Monitor your homework performance": "गृहकार्य का परिणाम देखें",
    "Select Time Period": "समय अवधि-चयन",
    "Time": "समय",
    "Apply": "लागू करें",
    "Clear": "हटाएं",
    "Clear All": "सभी हटाएं",
    "All Subjects Selected": "सभी विषय चयनित",
    "Yesterday": "कल",
    "This Week": "इस सप्ताह",
    "Last Week": "पिछले सप्ताह",
    "Last Month": "पिछले महीने",
    "Custom": "स्वनिर्धारित",
  }
}


const formatLangData = () => {
  const formattedObj = {};
  if (multiLangData[lang] && Object.keys(multiLangData[lang]).length) {
    Object.keys(multiLangData[lang]).forEach(key => {
      formattedObj[key.toLowerCase()] = multiLangData[lang][key];
    })
  }
  return formattedObj;
}


const handleLanguageChange = (text) => {
  const langData = formatLangData()
  text = text ? text.trim() : text;


  if (langData && Object.keys(langData).length && text) {
    if (langData[text.toLowerCase()]) {
      return langData[text.toLowerCase()]
    }
    else {
      return text;
    }
  }
  return text
}

const handleStringLength = (text, length) => {
  if(text) {
    if(text?.length > length) {
      return text.substring(0, length) + '...';
    } else {
      return text;
    }
  } else {
    return text;
  }
  
}

export { multiLangData, handleLanguageChange, lang, setLanguage, updateLanguage, handleStringLength };